import { Box, Typography } from "@mui/material";
import { COLORS } from "assets";
import { ReactNode } from "react";

export interface DetailFieldProps {
  label: string;
  value?: ReactNode;
}

export default function DetailField({ label, value }: DetailFieldProps) {
  return (
    <Box>
      <Typography
        variant="caption"
        display="block"
        lineHeight={1.2}
        sx={{ color: COLORS.primary, fontWeight: 600, mb: 0.25 }}
      >
        {label}
      </Typography>
      <Typography variant="body2" sx={{ color: COLORS.surface.primaryText, wordBreak: "break-word" }}>
        {value || "—"}
      </Typography>
    </Box>
  );
}
